import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'b64ToString'
})
export class B64ToStringPipe implements PipeTransform {
    transform(b64encoded: any, args?: any): any {
        if (typeof b64encoded === 'string' && b64encoded) {
            try {
                return atob(b64encoded);
            } catch (e) {
                return b64encoded;
            }
        }
        return b64encoded;
    }
}
